import React, { useEffect } from 'react'
import Header from '../Header/Header'
import Nav from '../Header/Nav'
import ContactContent from './ContactContent'
import Footer from '../Footer/Footer'
import WhatssapIcon from '../Home/WhatssapIcon'

const Contact = () => {

    

    useEffect(() => {
        // This is more reliable for sticky headers
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);

    return (
        <div className="flex flex-col min-h-screen bg-white">
            <Header />

            {/* Nav with target set to contact for active link highlighting */}
            <Nav target="contact" />

            <main className="flex-grow">
                <ContactContent />
            </main>

            <WhatssapIcon />

            <Footer />
        </div>
    )
}

export default Contact;